import React, { FC, useState, useEffect } from 'react'
import { createStyles, makeStyles, Fab, Paper, Box, Zoom, CircularProgress } from '@material-ui/core'
import { RouteComponentProps } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import { ReduxStore } from '../../stores';
import { TagState, Tag } from '../../Models/Tag/@types';
import TagForm from '../../Features/Tags/TagForm';
import SelectableTagsChipsList from '../../Features/Tags/SelectableTagsChipsList';
import CircularLoader from '../../Components/Loader/CircularLoader';
import { TDispatch } from '../../Resources/GarbageUtils';
import { OTag } from '../../Models/Tag';
import utilities from '../../Resources/Utils';

type IState = Pick<TagState, 'list'>;

interface TagsProps extends RouteComponentProps { }

const Tags: FC<TagsProps> = (props) => {

    const { list = [] } = useSelector<ReduxStore, IState>(({ Tag: { list } }) => ({ list }));
    const [showForm, setShowForm] = useState(false);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch<TDispatch>();
    const [selectedTags, setSelectedTags] = useState<Tag[]>([]);
    const [editedTag, setEditedTag] = useState<Tag>();
    const [deleteLoading, setDeleteLoading] = useState(false);

    const getData = async () => {
        setLoading(true);
        await dispatch(OTag.getItemsList()).catch(error => { console.log('Error', error, error.response) });
        setLoading(false);
    }

    useEffect(() => {
        getData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onToggleItem = (item: Tag) => setSelectedTags(utilities.toggleItemFromList(selectedTags, item));

    const handleEdit = () => { setEditedTag(selectedTags[0]); setShowForm(true); }

    const handleAdd = () => { setEditedTag(undefined); setShowForm(true); }

    const handleDelete = async () => {
        setDeleteLoading(true);
        await dispatch(OTag.deleteItemsList({ ids: selectedTags.map(x => x.id) }, {}, { selectedTags }));
        setSelectedTags([]);
        setDeleteLoading(false);
    }

    const classes = useStyles();

    return (
        <Box className={classes.root} >
            <Paper className={classes.paper} >
                {
                    loading ? <CircularLoader /> :
                        <SelectableTagsChipsList color={'primary'} tags={list} selectedTags={selectedTags} onToggle={onToggleItem} />
                }
            </Paper>
            <Box className={classes.tabActionButtons} >
                <Zoom in={selectedTags.length === 1} >
                    <Box mb={1} ><Fab onClick={handleEdit} color="secondary"><i className='material-icons' >edit</i></Fab></Box>
                </Zoom>
                <Zoom in={selectedTags.length > 0} >
                    <Box mb={1} >
                        <Fab disabled={deleteLoading} onClick={handleDelete} color="secondary">
                            {
                                deleteLoading ?
                                    <CircularProgress /> :
                                    <i className='material-icons' >delete</i>
                            }
                        </Fab>
                    </Box>
                </Zoom>
                <Fab onClick={handleAdd} color="secondary"><i className='material-icons' >add</i></Fab>
            </Box>
            {showForm ? <TagForm editedTag={editedTag} open={showForm} onCloseButtonClick={() => setShowForm(false)} /> : null}
        </Box>
    )
}

const useStyles = makeStyles((theme) => {
    return (createStyles({
        root: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            padding: '50px 0px'
        },
        paper: {
            width: 800,
            height: '100%',
            padding: 20,
            display: 'flex',
            flexDirection: 'column'
        },
        tabActionButtons: {
            position: 'fixed',
            right: '24px', bottom: '24px',
            display: 'flex',
            flexDirection: 'column',
        },
    }))
})

export default Tags